import React from 'react';
import auth from '../components/common/Auth';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import allActions from '../actions';
import { reducers } from '../store/storeRedux';
import types from '../types/types';

// This component ensure to clean all client's variables and sent the user to Auth0 login page.
export const Landing = (props) => {

    const { logout } = useAuth0();

    console.log("User Logout...");
    auth.cleanStorage();
    // TODO: Analyze next lines in order to findout if is necesarie to "restart" redux here (and if is correct the implementation of "types.restart_redux_on_logout").
    reducers(undefined, types.restart_redux_on_logout);
    logout({ returnTo: window.location.origin })
    // loginWithRedirect();

    return (null);
};

export default Landing;
